const objCookie = {
    /**
     * 写入cookie
     * @param {string} name  [cookie name]
     * @param {any} value [cookie value]
     * @param {string} days
     */
    setCookie(name: string, value: any, days: number) {
      const d = new Date()
      d.setTime(Math.floor(d.getTime() + 24 * 60 * 60 * 1000 * days))
  
      window.document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`
    },
  
    /**
     * 获得cookie
     * @param  {string} name
     */
    getCookie(name: string) {
      const v = window.document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
  
      return v ? v[2] : null
    },
  
    /**
     * 删除cookie
     * @param  {string} name
     */
    deleteCookie(name: string) {
      this.setCookie(name, '', -1)
    }
  }
  
  const objStorage = {
    /**
     * 本地存储数据
     * @param {string} key
     * @param {any} value
     */
    setLocalStorage(key: string, value: any) {
      window.localStorage.setItem(key, JSON.stringify(value))
    },
  
    /**
     * 获取本地存储数据
     * @param {string} key
     */
    getLocalStorage(key: string) {
      const obj = window.localStorage.getItem(key)
      if (obj && obj != 'undefined' && obj != 'null') {
        return JSON.parse(obj)
      }
      return ''
    },
  
    /**
     * 清除本地数据
     * @param {string} key
     */
  
    removeLocalStorage(key: string) {
      if (key) {
        window.localStorage.removeItem(key)
      } else {
        for (const i in arguments) {
          window.localStorage.removeItem(arguments[i])
        }
      }
    },
  
    /**
     * 清空本地数据
     * @param {string} key
     */
  
    clearLocalStorage(key: string) {
      localStorage.clear()
    }
  }
  export { objCookie, objStorage }
  